
export const storeQuestionarie = async (resource, data) => {
  let questionarie;
  await resource
    .post(`api/${localStorage.getItem('perfil')}/questionary`, data)
    .then(
      (response) => {
        console.log(response);
        questionarie = response.body.questionary;
      },
      (response) => {
        console.log(response);
      }
    );
  return questionarie;
}

export const getQuestionarie = async (resource, data) => {
  let questionarie;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/questionary/${data}`)
    .then(
      (response) => {
        questionarie = response.body.questionary;
        console.log(questionarie);
      },
      (response) => {
        console.log(response);
      }
    );
  return questionarie;
}

export const getQuestionariePublic = async (resource, data) => {
  let questionarie;
  await resource
    .get(`api/questionary/${data}`)
    .then(
      (response) => {
        questionarie = response.body.questionary;
        console.log(questionarie);
      },
      (response) => {
        console.log(response);
      }
    );
  return questionarie;
}

export const editQuestionarie = async (resource, id, data) => {
  let questionarie;
  await resource
    .put(`api/${localStorage.getItem('perfil')}/questionary/${id}`,data)
    .then(
      (response) => {
        console.log(response);
        questionarie = response.body.questionary;
      },
      (response) => {
        console.log(response);
      }
    );
  return questionarie;
}

export const changeStateQuestionarie = async (resource, id,state) => {
  let questionarie;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/questionary/${id}`)
    .then(
      async (response) => {
        let data={
          ...response.body.questionary,
          state:state
        }
        await resource.put(`api/${localStorage.getItem('perfil')}/questionary/${id}`,data).then((response)=>{
          questionarie=response.body.questionary
        })
      },      
    );
  return questionarie;
}
